import getModelByIdQuery from './getModelByIdQuery';
import { getModelBySkuQuery } from './getModelBySkuQuery';
import { getModelByEanQuery } from './getModelsByEanQuery';
import getModelsBySearchModelQuery from './getModelsBySearchModelQuery';
import { scanProductCommand } from './scanProductCommand';

const CatalogService = {
  getModelByIdQuery,
  getModelsBySearchModelQuery,
  scanProductCommand,
  getModelByEanQuery,
  getModelBySkuQuery,
};

export default CatalogService;
